import { createProjectPropertyResource } from './controllers/project-property-resource/index.tsx';

export const csmHubSetupResource = createProjectPropertyResource<Boolean>({
	propertyKey: 'csmHubSetup.collapsed',
	maxAge: 0,
});
